export enum CoverageStep {
    GridGeneration     = "GridGeneration",
    MatrixGeneration   = "MatrixGeneration",
    ProblemResolution  = "ProblemResolution",
    FinalSimulation    = "FinalSimulation",
    Configuration      = "Configuration"
  }

export const getCoverageStepTradKey = (covStep?:CoverageStep|null) => {
    switch(covStep){        
        case CoverageStep.GridGeneration: return "CoverageStep.GridGeneration"
        case CoverageStep.MatrixGeneration: return "CoverageStep.MatrixGeneration"
        case CoverageStep.ProblemResolution: return "CoverageStep.ProblemResolution"
        case CoverageStep.FinalSimulation: return "CoverageStep.FinalSimulation"
        default: return "CoverageStep.Configuration"
    }
}

export const getCoverageStep = (covStep?:string|null) => {
    switch(covStep) {
        case "GridGeneration": return CoverageStep.GridGeneration
        case "MatrixGeneration": return CoverageStep.MatrixGeneration
        case "ProblemResolution": return CoverageStep.ProblemResolution
        case "FinalSimulation": return CoverageStep.FinalSimulation        
        default: return CoverageStep.Configuration
    }
}